import react from 'react';
import { WizardStepperContextProvider } from './contexts/useWizardStepper.context';
import { WizardReportDataContextProvider } from './contexts/useWizardReportData.context';
import WizardDialogComponent from './components/wizard-dialog/wizard-dialog.component';


interface IProps {
    open: boolean;
    onClose: (reloadAll: boolean) => void;
    reportCode: string | undefined | null;
}
/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardReportComponent(props: IProps) {

    return (
        <WizardReportDataContextProvider isNewReport={!props.reportCode}>
            <WizardStepperContextProvider isNewReport={!props.reportCode}>

                <WizardDialogComponent {...props} />

            </WizardStepperContextProvider>
        </WizardReportDataContextProvider>
    );
}